define(["require", "exports", "../schema/data-schema.class"], function (require, exports, data_schema_class_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    /**
     * Created by Christophe on 17/10/2017.
     */
    var Structure = /** @class */ (function () {
        function Structure(func, _defaultValue) {
            this._defaultValue = _defaultValue;
            this._stack = [];
            this._stack.push(func);
        }
        Structure.prototype.nonNull = function () {
            this._stack.push(function (value) {
                return value !== null;
            });
            return this;
        };
        Structure.prototype.custom = function (func) {
            this._stack.push(function (value) {
                return func(value);
            });
            return this;
        };
        Structure.prototype.getStackValidity = function (value) {
            for (var _i = 0, _a = this._stack; _i < _a.length; _i++) {
                var func = _a[_i];
                if (!func(value)) {
                    return false;
                }
            }
            return true;
        };
        Object.defineProperty(Structure.prototype, "defaultValue", {
            get: function () {
                if (this._defaultValue instanceof data_schema_class_1.DataSchema) {
                    return this._defaultValue.generateModel();
                }
                if (typeof this._defaultValue === "function") {
                    return this._defaultValue();
                }
                else {
                    return this._defaultValue;
                }
            },
            enumerable: true,
            configurable: true
        });
        return Structure;
    }());
    exports.Structure = Structure;
});
